import Loader from "react-loader-spinner"

import React, { useState } from "react"
import "./step3-register.scss"
import Button from "../../../shared/components/atoms/button/button"
import { withPrefix } from "gatsby"
import emailReguex from "../../../shared/utils/emailRegex"
import { registerStepDatalayer } from "../../../utils/registerDatalayer"
import RegisterService from "../../../shared/services/register-service"
import ModalUserExists from "../modal-user-exists/modal-user-exists"

const Step3Register = props => {
  const [confirmEmailError, setConfirmEmailError] = useState()
  const { loadingButton } = props

  if (props.userData) {
    if (
      props.userData.fullDate === "" ||
      props.userData.name === "" ||
      props.userData.lastName === ""
    ) {
      window.location.href = withPrefix("/fecha-de-nacimiento")
    }
  } else {
    if (typeof window !== "undefined") {
      window.location.href = withPrefix("/fecha-de-nacimiento")
    }
  }

  const isValidEmailConfirmation = () => {
    if (props.getValues("email") === props.getValues("confirmationEmail"))
      return true
    setConfirmEmailError("Los correos no coinciden.")
    return false
  }

  const checkEmail = async () => {
    let email = props.values.email
    if (email && email !== "") {
      let res = await RegisterService.checkEmail({ email })
      if (!res || res.status !== 200) {
        if (res.errorCode === "DEM241") {
          {props.setModalActive(
          <ModalUserExists 
            setModalActive={props.setModalActive} 
            title={`Hola ${res.data.name}`} 
            subDescription={'¡Estamos aquí para ayudarte en lo que necesites!'}
            description={
              <>
					   Tu cuenta ya está activa en nuestro Mundo Nosotras.
             Utilizaste el correo electrónico <b>{censorMail(res.data.email)}</b> y el número de celular {' '}
					    <b>{censorCellPhone(res.data.cellPhone)}</b>.
					     Si deseas, puedes actualizar tus datos, iniciar sesión o validar tu información nuevamente.{' '} <br/>
					    
				  </>}
          />
          )}
          return res.userMessage
        }
      } else {
        return true
      }
    }
  }

  const checkCellPhone = async () => {
    let cellPhone = props.values.cellPhone

    if (cellPhone && cellPhone !== "") {
      let cellPhoneWithPrefix = process.env.COUNTRY_PHONE_PREFIX + cellPhone
      let res = await RegisterService.checkPhone({
        cellPhone: cellPhoneWithPrefix,
      })
      if (!res || res.status !== 200) {
        if (res.errorCode === "DEM242") {
        {props.setModalActive(
          <ModalUserExists 
            setModalActive={props.setModalActive} 
            title={`Hola ${res.data.name}`} 
            subDescription={'¡Estamos aquí para ayudarte en lo que necesites!'}
            description={
              <>
					   Tu cuenta ya está activa en nuestro Mundo Nosotras.
             Utilizaste el correo electrónico <b>{censorMail(res.data.email)}</b> y el número de celular {' '}
					    <b>{censorCellPhone(res.data.cellPhone)}</b>.
					     Si deseas, puedes actualizar tus datos, iniciar sesión o validar tu información nuevamente.{' '} <br/>
					    
				  </>}
          />
          )}
          return res.userMessage
      
        }
      } else {
        return true
      }
    }
  }

  return (
    <>
      <form
        name="pre-register"
        onSubmit={props.handleSubmit(() => {
          if (isValidEmailConfirmation()) props.onSubmit("preRegister")
          registerStepDatalayer({ category: "registro_3", label: "siguiente" })
        })}
      >
        <div className="f-step-register-form">
          {props.existEmai && (
            <span className="f-step-register-form-error-generic">
              *Este correo ya ha sido registrado.
            </span>
          )}
          {props.existCellphone && (
            <span className="f-step-register-form-error-generic">
              *Este celular ya ha sido registrado.
            </span>
          )}
          <span className="f-step-register-form-error-generic">
            {Object.keys(props.errors).length > 0 &&
              props.errors.email?.type !== "DEM010" &&
              props.errors.email?.type !== "validate" &&
              props.errors.cellPhone?.type !== "validate" &&
              "*Debes completar todos los campos"}
          </span>
          <div className="f-step-register-form-item ">
            <div>
              <label>¿CUÁL ES TU CORREO?</label>
              <input
                type="email"
                name="email"
                maxLength="60"
                className={
                  props.errors.email
                    ? "f-form-email f-error-value"
                    : "f-form-email"
                }
                autoComplete="off"
                id={"outlined-email"}
                onBlur={props.handleChange}
                ref={props.register({
                  required: true,
                  pattern: emailReguex(),
                })}
              />
              <span className="f-step-register-form-error f-step-register-form-error-label">
                {props.errors.email && props.errors.email.type === "required"
                  ? ""
                  : props.errors.email && props.errors.email.type === "DEM010"
                  ? props.errors.email.message
                  : props.errors.email &&
                    props.errors.email.type === "validate" &&
                    props.errors.email.message}
              </span>
            </div>
            <div>
              <label>CONFIRMA TU CORREO</label>
              <input
                type="email"
                name="confirmationEmail"
                maxLength="60"
                onPaste={e => {
                  e.preventDefault()
                }}
                className={
                  props.errors.email
                    ? "f-form-email f-error-value"
                    : "f-form-email"
                }
                autoComplete="off"
                onBlur={() => {
                  setConfirmEmailError()
                }}
                onChange={() => {
                  setConfirmEmailError()
                }}
                ref={props.register({
                  required: true,
                  pattern: emailReguex(),
                })}
              />
              <span className="f-step-register-form-error f-step-register-form-error-label">
                {confirmEmailError}
              </span>
            </div>
          </div>
          <div className="f-step-register-form-item ">
            <div>
              <label>¿CUÁL ES TU CELULAR?</label>
              <input
                type="number"
                name="cellPhone"
                maxLength="60"
                className={
                  props.errors.cellPhone || props.existCellphone
                    ? "f-form-cellPhone f-error-value"
                    : "f-form-cellPhone"
                }
                autoComplete="off"
                id={"outlined-cellPhone"}
                onBlur={props.handleChange}
                onChange={e => {
                  if (e.target.value === "") {
                    props.setValue("codeDestination", "EMAIL")
                    props.setValues({
                      ...props.values,
                      ["codeDestination"]: "EMAIL",
                    })
                  }
                }}
                ref={props.register({
                  maxLength: parseInt(process.env.MAX_DIGITS),
                  minLength: parseInt(process.env.MIN_DIGITS),
                  min: 0,
                  pattern: "\d*",
                  required: process.env.LOCALE === "es-AR",
                })}
              />
              <span className="f-step-register-form-error f-step-register-form-error-label">
                {props.errors.cellPhone &&
                props.errors.cellPhone.type === "required"
                  ? ""
                  : props.errors.cellPhone &&
                    props.errors.cellPhone.type === "validate"
                  ? props.errors.cellPhone.message
                  : props.errors.cellPhone && "*Celular inválido"}
              </span>
            </div>
            <div>
              <label>¿POR QUÉ MEDIO QUIERES ACTIVAR TU CUENTA?</label>
              <div className="f-step-register-form-item ">
                <div className="f-step-register-form-radio">
                  Mi correo
                  <input
                    type="radio"
                    defaultChecked
                    name="codeDestination"
                    onChange={props.handleChange}
                    value="EMAIL"
                    ref={props.register}
                  />
                  <span className="checkmark"></span>
                </div>
                <div className="f-step-register-form-radio">
                  Mi celular (SMS)
                  <input
                    type="radio"
                    name="codeDestination"
                    onChange={props.handleChange}
                    value="SMS"
                    ref={props.register}
                  />
                  <span className="checkmark"></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={
            !props.loadServer
              ? "f-step-register-buttons"
              : "f-step-register-buttons f-step-register-buttons-disable"
          }
        >
          {loadingButton ? (
            <Loader type="TailSpin" color="#FF409B" height={50} width={50} />
          ) : (
            <Button
              className="new-primary-pink short f-btn-form-nextStep"
              title="Siguiente"
              type="submit"
            />
          )}
          <Button
            onClick={e => {
              registerStepDatalayer({
                category: "registro_3",
                label: "anterior",
              })
              props.hadleBack && props.hadleBack(e)
            }}
            className="new-primary-pink--outline short f-btn-form-prevStep"
            title="Anterior"
          />
        </div>
      </form>
    </>
  )
}

export default Step3Register
